import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Outlet, Link, useLocation } from 'react-router-dom';
import './CreateReportPage.css';

interface CreateReportPageProps {
  isStepPage?: boolean;
  children?: React.ReactNode;
}

const CreateReportPage: React.FC<CreateReportPageProps> = ({ isStepPage = false, children }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  // Перенаправляем на шаг загрузки файла, если это главная страница
  useEffect(() => {
    if (!isStepPage) {
      navigate(`/create-report/upload`);
    }
    
    // Добавляем класс к body для скрытия header и footer
    document.body.classList.add('fullscreen-mode');
    
    // Очистка при размонтировании
    return () => {
      document.body.classList.remove('fullscreen-mode');
    };
  }, [isStepPage, navigate]);

  // Определяем, находимся ли мы на странице ProcessingStep
  const location = useLocation();
  const isProcessingStep = location.pathname.includes('/processing');

  // Мемоизируем содержимое страницы
  const pageContent = useMemo(() => {
    if (!isStepPage) {
      return (
        <div className="immersive-container">
          <div className="create-report-page">
            <p>{t('redirecting')}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="immersive-container">
        {/* Отображаем кнопку "Главная" только если это не страница ProcessingStep */}
        {!isProcessingStep && (
          <div className="home-button-container">
            <Link to="/reports" className="home-button">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15" 
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{t('home')}</span>
            </Link>
          </div>
        )}
        <div className="create-report-page">
          <div className="step-content">
            {children || <Outlet />}
          </div>
        </div>
      </div>
    );
  }, [isStepPage, children, isProcessingStep]);

  return pageContent;
};

export default CreateReportPage;
